import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { getLegalManifestTicketDetail } from '../../../../actions/legal/LegalManifestTickets'
import Table from '../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';
import { LEGAL_MANIFEST_PASSENGER_DETAIL_COLUMNS } from '../../../../config/columns';

const LegalManifestTicket = ({ dispatchGetLegalManifestTicketDetail, idSourceSystem }) => {

  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      const result = await dispatchGetLegalManifestTicketDetail({ idSourceSystem });
      setDetails(Array.isArray(result) ? result : []);
      setLoading(false);
    };

    fetchDetails();

  }, [])

  return (
    <>
      <h3>Detalle del Manifiesto de Pasajeros</h3>
      <Table
        manual={false}
        columns={LEGAL_MANIFEST_PASSENGER_DETAIL_COLUMNS}
        data={details}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        filterable
        defaultFilterMethod={filterMethodCaseInsensitive}
        loading={loading}
      />
    </>
  )
}

LegalManifestTicket.propTypes = {
  dispatchGetLegalManifestTicketDetail: PropTypes.func.isRequired,
  idSourceSystem: PropTypes.string.isRequired,
}


const mapDispatchToProps = {
  dispatchGetLegalManifestTicketDetail: getLegalManifestTicketDetail,
}


export default connect(null, mapDispatchToProps)(LegalManifestTicket);
